// ====================== PC端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("[data-timeline-slider]");
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.style.cursor = "grabbing";
    // 滑动开始时禁止全局选中
    document.body.style.userSelect = "none";
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.style.cursor = "grab";
    document.body.style.userSelect = "";
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.style.cursor = "grab";
    document.body.style.userSelect = "";
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});

// ====================== 移动端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  // 移动端折叠/展开
  const mobileWrapper = document.querySelector(".timeline-container-mobile");
  if (!mobileWrapper) return;

  const mobileItems = mobileWrapper.querySelectorAll("[data-mobile-item]");
  const loadMoreBtn = mobileWrapper.querySelector("[data-loadmore]");
  const hiddenItems = mobileWrapper.querySelectorAll(".timeline-item-hidden");
  // 默认收起的高度（和你写的一致：1行文字高度）
  const DEFAULT_LINE_HEIGHT = 'calc(12px * 1.5 * 1)';
  // 动画时长（统一管理）
  const ANIMATION_DURATION = '0.6s cubic-bezier(.22,1,.36,1)';

  // ====================== 点击展开逻辑 ======================
  const handleExpand = (desc) => {
    // 取消文本省略限制
    desc.style.webkitLineClamp = 'unset';
    desc.style.overflow = 'visible';
    desc.style.display = 'block';

    // 计算文本真实高度
    desc.style.height = 'auto';
    const fullHeight = desc.offsetHeight;
    // 先重置为默认单行高度
    desc.style.height = DEFAULT_LINE_HEIGHT;

    desc.clientHeight; // 强制浏览器重绘，触发动画

    // 执行展开动画
    desc.style.transition = ANIMATION_DURATION;
    desc.style.height = fullHeight + 'px';
  };

  // ====================== 点击收起逻辑 ======================
  const handleCollapse = (desc) => {
    // 执行收起动画
    desc.style.transition = ANIMATION_DURATION;
    desc.style.height = DEFAULT_LINE_HEIGHT;

    // 动画结束后，恢复文本省略样式（时间和动画时长一致）
    setTimeout(() => {
      desc.style.webkitLineClamp = '1'; // 恢复1行省略
      desc.style.overflow = 'hidden';
      desc.style.display = '-webkit-box';
      desc.style.webkitBoxOrient = 'vertical';
    }, 600); // 对应0.6s动画
  };

  // ====================== 点击切换展开/关闭 ======================
  mobileItems.forEach((item) => {
    item.addEventListener("click", () => {
      const desc = item.querySelector(".timeline-mobile-desc .timeline-mobile-desc-content");
      if (!desc) return;

      // 核心：判断当前状态 → 展开/收起二选一
      if (item.classList.contains("active")) {
        // 已有active：执行收起
        handleCollapse(desc);
      } else {
        // 无active：执行展开
        handleExpand(desc);
      }

      // 切换激活状态类
      item.classList.toggle("active");
    });
  });

  // ====================== 加载更多【展开/收缩切换】逻辑 ======================
  if (loadMoreBtn && hiddenItems.length > 0) {
    loadMoreBtn.addEventListener("click", () => {
      hiddenItems.forEach((item) => {
        item.classList.toggle("show");
      });
      loadMoreBtn.classList.toggle("rotate");
    });
  }
});
